import React from 'react';
import { Switch } from 'react-router-dom';

import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';

import AidasProjectProperty from './aidas-project-property';
import AidasProjectPropertyDetail from './aidas-project-property-detail';
import AidasProjectPropertyUpdate from './aidas-project-property-update';
import AidasProjectPropertyDeleteDialog from './aidas-project-property-delete-dialog';

const Routes = ({ match }) => (
  <>
    <Switch>
      <ErrorBoundaryRoute exact path={`${match.url}/new`} component={AidasProjectPropertyUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id/edit`} component={AidasProjectPropertyUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id`} component={AidasProjectPropertyDetail} />
      <ErrorBoundaryRoute path={match.url} component={AidasProjectProperty} />
    </Switch>
    <ErrorBoundaryRoute exact path={`${match.url}/:id/delete`} component={AidasProjectPropertyDeleteDialog} />
  </>
);

export default Routes;
